// extracted by mini-css-extract-plugin
module.exports = {"spinner":"YELTx","lightArc":"_24OF_","darkArc":"_1PL9z","rotation":"_3E5jg"};